//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tidalImage from '@tidal/styles-image/src/components/tidal-image.vue';
import tidalLogo from './tidalLogoComponent.vue';

export default {
    components: {
        tidalImage,
        tidalLogo,
    },
    props: {
        user: {
            type: Object,
            default: null,
        },
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        showNav: {
            type: Boolean,
            default: false,
        },
        art: {
            type: Object,
            default: null,
        },
        coBrandedLogin: {
            type: Object,
            default: null,
        },
        /** @type {import('vue').PropOptions<import('@tidal/user-middleware').AppMode | null>} */
        appMode: {
            type: Object,
            default: null,
        },
        brandedLogin: {
            type: Boolean,
            default: false,
        },
        customPartnerLogoUrl: {
            type: String,
            default: '',
        },
        opaqueLogo: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            menuToggled: false,
            menuShowClass: '',
        };
    },
    computed: {
        /** @returns {string} */
        titleClasses() {
            if (this.art && this.art.show && (!this.appMode || !this.appMode.mobile)
                && (!this.coBrandedLogin || !this.coBrandedLogin.enabled)) {
                return 'col-9 col-md-9 col-sm-9 margin-bottom-1';
            } else {
                return 'col-12 col-md-12 col-sm-12 text-center margin-bottom-nudge-1';
            }
        },
        /** @returns {string} */
        headerTitle() {
            if (this.coBrandedLogin && this.coBrandedLogin.enabled) {
                return '';
            } else {
                return this.title;
            }
        },
        /** @returns {string} */
        headerSubtitle() {
            if (this.coBrandedLogin && this.coBrandedLogin.enabled) {
                return this.coBrandedLogin.description;
            } else {
                return this.subtitle;
            }
        },
        /** @returns {boolean} */
        isClient() {
            return !!this.appMode;
        },
    },
};
